import Buttons from "../button";
import Cliploader from "react-spinners/ClipLoader";

export interface RegistrationEmailSentViewProps {
  logo: string;
  title: string;
  email: string;
  isLoading: boolean;
  onSubmit: () => void;
  orgName?: string;
}

export const RegistrationEmailSentView = ({
  logo,
  title,
  email,
  isLoading,
  onSubmit,
  orgName = "",
}: RegistrationEmailSentViewProps) => {
  return (
    <>
      <div className="pt-12">
        <img
          src={logo}
          alt={`${orgName} logo`}
          className="bg-friendly-eskimo mx-auto h-[88px] w-[88px] rounded object-contain"
        />
      </div>
      <p className="text-medium-hippo font-inter pt-6 text-center text-base">
        {title}
      </p>
      <h1 className="text-charcoal font-inter px-6 pt-3 text-center text-4xl font-semibold">
        Please check your email!
      </h1>
      <p className="sr-only" role="alert" aria-live="assertive">
        Please check your email
      </p>
      <img
        src="/v2/email-yay.png"
        alt="Email Sent"
        className="mx-auto w-40 object-contain py-6"
      />
      <div className="space-y-6 px-8 py-6 text-center">
        <p className="font-inter text-medium-hippo pb-6 text-base">
          We have sent an email to{" "}
          <span className="font-semibold">{email}</span>.
        </p>
        <p className="font-inter text-medium-hippo gap-y-2 pb-6 text-base">
          You will need to verify your email through the link we have sent you
          to continue. Please check your spam if you don’t see it in your inbox.
        </p>
        <Buttons.Standard
          variant="primary-navy"
          className="w-full"
          onClick={(evt) => onSubmit()}
        >
          {isLoading ? (
            <Cliploader color="text-white" size={21} />
          ) : (
            "Resend Email"
          )}
        </Buttons.Standard>
      </div>
    </>
  );
};

export default RegistrationEmailSentView;
